import React from 'react';
import { ConfigProvider, message } from 'antd';
import { memo, useEffect } from 'react';
// import './styles.css';

/**
 * 画面上部に表示する小型ローディング
 * @param {string} message ローディング中に表示するメッセージ
 */
type SmallLoadingProps = {
    show?: boolean;
    content?: string;
};

const SmallLoading = memo(({ show = false, content = 'Loading...' }: SmallLoadingProps) => {
    const [messageApi, messageContextHolder] = message.useMessage();

    useEffect(() => {
        if (show) {
            messageApi.open({
                type: 'loading',
                content: content,
                duration: 0,
                className: 'smallLoading',
            });
        } else {
            messageApi.destroy();
        }
    }, [show, content, messageApi]);

    return (
        <>
            <ConfigProvider
                theme={{
                    token: {
                        // colorInfo: 'red',
                        // boxShadow: undefined
                    },
                }}
            >
                {messageContextHolder}
            </ConfigProvider>
        </>
    );
});

export default SmallLoading;
